'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pureGraph = require('pure-graph');

var _functional = require('utils/functional');

// import {randomElement} from 'utils/utils';

/* injects from baggage-loader */

var getDefaultProject = function getDefaultProject() {
  return {
    name: 'Hi there',

    nodesData: {
      first: { x: -20, y: -170, color: '#D0F192', caption: 'Sample node' },
      second: { x: 20, y: 0, color: '#6D826C', caption: 'Another sample node' }
    },

    graph: (0, _functional.compose)((0, _pureGraph.addEdge)('first-second', 'first', 'second'), (0, _pureGraph.addNode)('first'), (0, _pureGraph.addNode)('second'))(_pureGraph.EMPTY_GRAPH)
  };
};

exports.default = getDefaultProject;


//////////////////
// WEBPACK FOOTER
// ./app/reducers/defaultProjectData.js
// module id = 623
// module chunks = 1